import { useCallback } from 'react';
import { LOCAL_STORAGE_KEY_HOTLINE_CLIENT_NEGOTIATE_CLIP } from '@/utils/constants/storage/localStorageKey';
import { useLocalStorage } from '@/utils/libs/react-hookz/useLocalStorage';
/**
 * ホットライン クリップ機能の hook
 */
export const useHotlineClientDetailClip = (options) => {
    const { id } = options;
    // クリップの有無のデータを保存
    const { set: setClipList, value: clipList } = useLocalStorage(LOCAL_STORAGE_KEY_HOTLINE_CLIENT_NEGOTIATE_CLIP, {
        defaultValue: {},
    });
    /**
     * クリップの状態更新
     */
    const updateClipState = useCallback((requestId) => {
        setClipList((prev) => {
            const prevList = (prev === null || prev === void 0 ? void 0 : prev[id]) || [];
            let newList = [];
            if (!prevList.includes(requestId)) {
                // 既存のデータに ID がない場合は追加
                newList = [...prevList, requestId];
            }
            else {
                // 既存のデータに ID がある場合は削除
                newList = prevList.filter((request) => request !== requestId);
            }
            return Object.assign(Object.assign({}, prev), { [id]: newList });
        });
    }, [id, setClipList]);
    return {
        requestClipList: (clipList === null || clipList === void 0 ? void 0 : clipList[id]) || [],
        updateClipState,
    };
};
